import { alert, AlertVariant } from '@repo/themes/styled-system/recipes';
import { ComponentProps } from 'react';

const classes = alert();

export interface AlertProps
  extends Partial<AlertVariant>,
    ComponentProps<'div'> {}

const AlertContainer = ({ children, ...allProps }: AlertProps) => {
  const [alertProps, props] = alert.splitVariantProps(allProps);
  const classes = alert(alertProps);

  return (
    <div className={classes.root} {...props}>
      {children}
    </div>
  );
};

const AlertHeading = ({ children }: { children: React.ReactNode }) => {
  return <div className={classes.heading}>{children}</div>;
};

const AlertContent = ({ children }: { children: React.ReactNode }) => {
  return <p className={classes.content}>{children}</p>;
};

AlertContainer.displayName = 'Alert.Container';
AlertHeading.displayName = 'Alert.Heading';
AlertContent.displayName = 'Alert.Content';

export default {
  Container: AlertContainer,
  Heading: AlertHeading,
  Content: AlertContent,
};
